import { inject, observer } from 'mobx-react';
import { ReactComponent as ForwardIcon } from "../../svg/bring-forward.svg";
import { ReactComponent as FullForward } from "../../svg/bring-to-front.svg";
import { ReactComponent as FullBack } from "../../svg/send-to-back.svg";
import { ReactComponent as BackwardIcon } from "../../svg/send-backward.svg";
import React from 'react'

@inject('workAreaStore') @observer
class ShiftMenu extends React.Component {

  handleShiftClick(toFront = false){
    const { pageIdx, layerIdx } = this.props.workAreaStore.findLayerIdx(this.props.workAreaStore.selectedLayer)
    if(pageIdx > -1){
      this.props.workAreaStore.shiftLayerIndex(this.props.workAreaStore.selectedLayer, toFront, pageIdx)
    }
  }

  handleFullShiftClick(toFront = false){
    const { pageIdx } = this.props.workAreaStore.findLayerIdx(this.props.workAreaStore.selectedLayer)
    if(pageIdx > -1){
      this.props.workAreaStore.shiftLayerFully(this.props.workAreaStore.selectedLayer, toFront, pageIdx)
    }
  }
  

  render(){
    return (
      <div className='shift-menu'>
        <div className='shift-menu__item'>
          <span className='shift-menu__item__text' onClick={() => this.handleShiftClick(true)}>
            <ForwardIcon />
            Shift forward
          </span>
          <span className='shift-menu__item__text' onClick={() => this.handleShiftClick()}>
            <BackwardIcon />
            Shift backward
          </span>
        </div>
        <div className='shift-menu__item border-top'>
          <span className='shift-menu__item__text' onClick={() => this.handleFullShiftClick(true)}>
            <FullForward />
            Bring to front
          </span>
          <span className='shift-menu__item__text' onClick={() => this.handleFullShiftClick(false)}>
            <FullBack />
            Send to back
          </span>
        </div>
      </div>
    )
  }

}

export default ShiftMenu